<template>
	<q-page-sticky position="bottom-right" :offset="[18, 18]" class="add-transcript-sticky" v-if="visible">
		<q-btn round push color="primary"
			@click="click"
			icon="add"
			class="shadow-8"
			size="lg"
		>
			<q-tooltip anchor="center left" self="center right" :offset="[20, 0]">
				{{ label }}
			</q-tooltip>
		</q-btn>
	</q-page-sticky>
</template>

<script lang="ts">
import { Prop, Component, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class AddTranscriptButtons extends Vue {
	@Prop() public visible!: boolean;
	@Prop() public label!: string;

	@Emit('click')
	public click() { /* */ }
}
</script>

<style>
	.add-transcript-sticky { z-index: 5999; }
</style>